export enum StatsEnum {
  SET_STATS = 'stats',
  INCREMENT_FONTS_COUNTER = 'stats:increment:fontsCounter',
  INCREMENT_USERS_COUNTER = 'stats:increment:usersCounter',
}
